import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type IncidentPriorityIconProps = {
  size?: number
  priority?: string | null
  colorScheme?: 'dark' | 'light'
  className?: string
}

const getActiveBars = (priority: string | null | undefined): number => {
  switch (priority?.toLowerCase()) {
    case 'low':
      return 1
    case 'medium':
      return 2
    case 'high':
      return 3
    default:
      return 0
  }
}

const UrgentIcon = ({
  size,
  className,
}: {
  size: number
  className?: string
}) => (
  <svg
    aria-label='Priority'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 20 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.0029 5.87305V17.6182L10.1816 23.4912L0.360352 17.6182V5.87305L10.1816 0L20.0029 5.87305ZM9.00977 15.3916V17.7578H11.376V15.3916H9.00977ZM8.94434 6.04004L9.4502 14.2168H10.9189L11.4258 6.04004H8.94434Z'
      fill='#A62630'
    />
  </svg>
)

export const IncidentPriorityIcon = ({
  size = 20,
  priority,
  colorScheme = 'dark',
  className,
}: IncidentPriorityIconProps) => {
  const normalizedPriority = priority?.toLowerCase()
  if (normalizedPriority === 'urgent' || normalizedPriority === 'critical') {
    return <UrgentIcon className={className} size={size} />
  }

  const activeColor =
    colorScheme === 'dark'
      ? '#ffffff'
      : tokenVar('colors.icon.priority-inactive')
  const inactiveColor =
    colorScheme === 'dark'
      ? tokenVar('colors.icon.secondary')
      : tokenVar('colors.icon.priority-active')
  const activeBars = getActiveBars(priority)

  return (
    <svg
      aria-label='Priority'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        fill={activeBars >= 1 ? activeColor : inactiveColor}
        height='6'
        rx='1'
        width='4'
        x='3'
        y='14'
      />
      <rect
        fill={activeBars >= 2 ? activeColor : inactiveColor}
        height='11'
        rx='1'
        width='4'
        x='10'
        y='9'
      />
      <rect
        fill={activeBars >= 3 ? activeColor : inactiveColor}
        height='16'
        rx='1'
        width='4'
        x='17'
        y='4'
      />
    </svg>
  )
}
